import React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

/**
 * Standard "Back" link used at the top of Add/Edit forms and drill-down
 * sub-pages. Calls navigate(-1) by default, or a custom onClick if given.
 */
const BackLink = ({ onClick, sx }) => {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-start", pl: "15px", ...sx }}>
      <Button
        variant="text"
        color="primary"
        size="small"
        startIcon={<ArrowBackIcon fontSize="small" />}
        onClick={onClick || (() => navigate(-1))}
        sx={{ fontWeight: 500, "&:hover": { bgcolor: "action.hover" } }}
      >
        Back
      </Button>
    </Box>
  );
};

export default BackLink;
